import styled from 'styled-components';

const StyledAvatarContainer = styled.div<{ size: string }>`
  position: relative;
  width: ${({ size }) => size};
`;

const StyledAvatarCircle = styled.div<{
  size: string;
}>`
  background-size: 100% auto;
  border-radius: 50%;
  box-sizing: border-box;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  svg {
    overflow: visible;
  }
`;

const StyledAvatarImage = styled(StyledAvatarCircle)<{ backgroundUrl: string }>`
  background-image: ${({ backgroundUrl }) => `url('${backgroundUrl}')`};
`;

const StyledPresenceCircle = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.icon.success};
  border: ${(props) => `${props.theme.border['xs']} solid ${props.theme.border.inverse}`};
  border-radius: 50%;
  right: 0;
  top: 0;
  min-height: ${(props) => props.theme.spacing['md']};
  min-width: ${(props) => props.theme.spacing['md']};
  height: ${(props) => props.theme.spacing['md']};
  width: ${(props) => props.theme.spacing['md']};
`;

export { StyledAvatarContainer, StyledAvatarCircle, StyledAvatarImage, StyledPresenceCircle };
